import {
  Box,
  Button,
  Checkbox,
  ListItemText,
  MenuItem,
  Popover,
} from '@mui/material';
import { ReactNode } from 'react';
import { StatusBadge } from 'src/components/atoms/status-badge';
import { usePopover } from 'src/hooks/use-popover';

export interface Option {
  value: string;
  label: string;
  color?: string;
  leadingSlot?: ReactNode;
  icon?: ReactNode;
}

interface Props {
  selected: string[];
  onChange: (value: string) => void;
  options: Option[];
  title: string;
  withStatusBadge?: boolean;
  minButtonWidth?: number;
}

export const FilterPopover = ({
  onChange,
  options,
  selected,
  title,
  withStatusBadge,
  minButtonWidth,
}: Props) => {
  const [anchorRef, open, handleOpen, handleClose] = usePopover();

  return (
    <>
      <Button
        color="primary"
        onClick={handleOpen}
        size="medium"
        sx={{ textWrap: 'nowrap', minWidth: minButtonWidth, flexShrink: 0 }}
        variant="outlined"
        id={`${title}-status_button`}
        ref={anchorRef}>
        {title}
      </Button>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: {
            width: 220,
            display: 'flex',
            flexDirection: 'column',
          },
        }}>
        {options?.map(option => (
          <MenuItem
            key={option.value.toString()}
            value={option.label}
            onClick={() => onChange(option.value)}>
            <Checkbox
              checked={selected ? selected.includes(option.value) : false}
              id={`${option.label}-filters_${option.value}`}
              sx={{ mr: 1 }}
            />
            {option.leadingSlot ?? null}
            {withStatusBadge && option.color ? (
              <StatusBadge sx={{ mr: 1 }} color={option.color} />
            ) : null}
            {option.icon ? (
              <Box
                sx={{
                  mr: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                {option.icon}
              </Box>
            ) : null}
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};
